import { useParams } from "react-router-dom";
import useLoading from "../../../../shared/components/loading/useLoading";
import useAxios from "../../../../hooks/useAxios";
import { useEffect, useState } from "react";
import { ROLES } from "../../../../shared/lib/routesResolver";
import BreadcrumbPanel from "../../../../shared/components/breadcrumb/BreadcrumbPanel";
import {
  API_PERMISSIONS,
  API_ROLE_BY_UD,
  API_ROLE_USERS_BY_ID,
} from "../../../../shared/lib/apiEndpointsResolver";
import { catchFunction } from "../../../../shared/lib/utils";
import RoleInfoPanel from "./RoleInfoPanel";
import RoleInfoTabMenu from "./RoleInfoTabMenu";

const RoleDetail = () => {
  const { id } = useParams();
  const { setLoading } = useLoading();
  const axios = useAxios();
  const [role, setRole] = useState();
  const [users, setUsers] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const breadcrumbItems = [
    { title: "Roles", link: ROLES },
    { title: role?.name },
  ];

  const findRole = () => {
    setLoading(true);
    axios
      .get(API_ROLE_BY_UD(id))
      .then((response) => setRole(response.data))
      .catch(catchFunction)
      .finally(() => setLoading(false));
  };

  const findUsersByRole = () => {
    axios
      .get(API_ROLE_USERS_BY_ID(id))
      .then((response) => setUsers(response.data))
      .catch(catchFunction);
  };

  const findRolePermissions = () => {
    axios
      .get(`${API_PERMISSIONS}?role=${id}`)
      .then((response) => setPermissions(response.data))
      .catch(catchFunction)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    findRole();
    findUsersByRole();
    findRolePermissions();
  }, [id]);

  return (
    <>
      <div className="px-4 pb-4 sm:px-6">
        <BreadcrumbPanel items={breadcrumbItems} />
      </div>
      <div className="flex flex-col gap-y-4">
        <div className="flex flex-row justify-between gap-x-4 px-4">
          <RoleInfoPanel role={role} />
          <div></div>
        </div>
        <RoleInfoTabMenu users={users} permissions={permissions} />
      </div>
    </>
  );
};

export default RoleDetail;
